const e = "{{value, currency}}", t = "Loan with a residual payment", n = "Apply", a = "Reset", r = { title: "Select a loan program", empty: { title: "Alas, no loan programs were found", text: "Unfortunately, we were unable to find results that fit all the criteria you selected. Try changing some of the loan parameters to continue" }, bank: "Bank", interestRate: "Loan rate, %", price: "Per month" }, o = { downPayment: "Down payment, %", residualPayment: "Residual payment, %", creditTerm: "Loan term, month." }, s = {
  currency: e,
  residualPayment: t,
  confirm: n,
  reset: a,
  programs: r,
  sliders: o
};
export {
  n as confirm,
  e as currency,
  s as default,
  r as programs,
  a as reset,
  t as residualPayment,
  o as sliders
};
